export default "__VITE_PUBLIC_ASSET__1eceb0c0__"